export default __webpack_public_path__ + "static/media/free_virgin_image.9fef35b6.png";